module.exports = __webpack_public_path__ + "img/1.0bd623b3.png";